import { API_URL } from "../constants/url";

const SERVER_PREFIXES = ["/uploads/", "uploads/"];

export const resolveMediaUrl = (url?: string | null): string => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const apiBase = API_URL.replace(/\/api\/v1\/admin\/?$/, "");
  const base = apiBase.endsWith("/") ? apiBase.slice(0, -1) : apiBase;
  const path = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${base}${path}`;
};

export const isPdfUrl = (url?: string | null): boolean =>
  Boolean(url && /\.pdf(\?|#|$)/i.test(url));
